var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 51,
    viewBox: "0 0 10 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6 0.5L5.2 0.95L9.2 3.95L8 5.55L5.6 3.75L5.6 47.75L8 45.95L9.2 47.55L5.2 50.55L4.6 51L4 50.55L0 47.55L1.2 45.95L3.6 47.75L3.6 3.75L1.2 5.55L0 3.95L4 0.95L4.6 0.5Z",
    fill: "#12C971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpGreen);
export default __webpack_public_path__ + "static/media/RPGreen.6b00162cb8e15febb146f09e9eee0075.svg";
export { ForwardRef as ReactComponent };